import { LookupDetails } from "./editable-table-header.interface";
import { PermissionConditionSet } from "../services/permission.service";
import { DynamicFromDataType } from "../constants/dynamic-from-data-type";
import { Validator } from "./dynamic-form";

export interface TableMeta {
  name?: string;
  uniqueColumns?: string[],
  columns: ColumnDto[];
  actions?: ColumnDto[];
}



export interface ColumnDto {
  fieldName: string;
  displayName: string;
  hidden?: boolean;
  dataType?: TableDataType | string;
  columnType?: ColumnType | string;
  defaultValue?: any;
  valueMap?: {
    [key: string]: string;
  };
  editable?: boolean;
  editableConfig?: EditableConfig;
  actionConfig?: Action;
  linkInfo?: LinkInfo;
  filterable?: boolean;
  sortable?: boolean,
  styleConfig?: DisplayStyleConfig
  thStyleConfig?: any
}

export interface TableMenuOption {
  label: string;
  value: string;
  condition?: (record: any) => boolean;
  requiresPermission?: PermissionConditionSet
}

export interface TableBulkActionOption {
  label: string;
  value: string;
  type?: "primary" | "secondary" | "danger";
}

export interface TableBulkActionEvent {
  action: TableBulkActionOption;
  selectedItems: any[];
  allTableRecordsSelected: boolean;
}

export interface LinkInfo {
  url: string;
}


export enum TableDataType {
  STRING = "STRING",
  NUMBER = "NUMBER",
  BOOLEAN = "BOOLEAN",
  DATETIME = "DATETIME",
  DATE = "DATE",
  DATETIME_EPOCH = "DATETIME_EPOCH",
  ARRAY = "ARRAY",
  JSON = "JSON",
  OBJECT= "OBJECT",
  CURRENCY = "CURRENCY",
  DETERMINANT_RULES = "DETERMINANT_RULES"
}

export enum ColumnType {
  VALUE = "VALUE",
  ACTION = "ACTION"
}

export interface DisplayStyleConfig {
  type?: 'text' | 'badge' | 'status' | 'multi-tag' | 'user-avatar' | 'hyper-link' | 'button' | 'rules' | string;
  icon?: string;
  iconPosition?: 'left' | 'right' | string;
  styleProperties?: any,
  iconStyleProperties?: any,
  multiTagConfig?: MultiTagConfig;
  conditions?: ConditionConfig[];
}

export interface Action {
  label: string;
  actionName: string;
  writeOperation: boolean;
  conditions?: ActionConditionConfig[];
  confirmationRequired?: boolean;
  confirmationMessage?: string;
}

export interface MultiTagConfig {
  labelKey?: string,
  maxTagCount?: number,
  color?: string;
  backgroundColor?: string;
  orderedValueStyles?: MultiTagValueConfig[]
}

export interface MultiTagValueConfig {
  color?: string;
  backgroundColor?: string;
  styleProperties?: any,
}

export interface ConditionConfig {
  expression: string;
  styleProperties?: any,
  styleConfig?: DisplayStyleConfig
  iconStyleProperties?: any,
}

export interface ActionConditionConfig extends ConditionConfig {
  dependentField: string;
}

export interface EditableConfig {
  inputType: DynamicFromDataType;
  placeHolder?: string;
  defaultToCurrentDate?: boolean
  options?: any[];
  displayKey?: string;
  valueKey?: string;
  isMultiSelect?: boolean;
  lookupDetails?: LookupDetails;
  validators?: Validator[];
}
